/// <reference path="../../TypeLite.Net4.d.ts" />

//export type ApiResponse = Record<string, any>

export enum ServicePageActionTypes {
	FETCH_REQUEST_Service = '@@servicePage/FETCH_REQUEST',
	FETCH_SUCCESS_Service = '@@servicePage/FETCH_SUCCESS',
}

// Declare state types with `readonly` modifier to get compile time immutability.
export interface ServicePageState {
	readonly loading: boolean
	readonly data: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ServiceModel,
	readonly errors?: string
}
